import styled from 'styled-components'
import copy from 'copy.json'
import { CheckedIcon, CrossIcon } from 'icons'

type Props = {
  emailConfirmed: boolean
  contactEmail: string
}

const text_form = copy.common.form

export default function EmailConfirmation({ emailConfirmed, contactEmail }: Props) {
  return (
    <Wrapper emailConfirmed={emailConfirmed}>
      <span>{contactEmail}</span>
      <span>
        {emailConfirmed ? (
          <>
            <Checked /> <span>{text_form.status_active}</span>
          </>
        ) : (
          <>
            <UnChecked /> <span>{text_form.status_inactive}</span>
          </>
        )}
      </span>
    </Wrapper>
  )
}

const Checked = styled(CheckedIcon)`
  color: var(--green);
`

const UnChecked = styled(CrossIcon)`
  color: var(--orange);
`

const Wrapper = styled.div<{ emailConfirmed: boolean }>`
  display: flex;
  flex-wrap: wrap;
  row-gap: 8px;
  column-gap: 24px;

  svg {
    margin-right: 8px;
  }

  span:nth-of-type(2) {
    align-self: center;

    font: var(--600-12);
    color: ${props => (props.emailConfirmed ? 'var(--green)' : 'var(--orange)')};
  }
`
